import React, { useCallback, useState } from 'react';
import classNames from 'classnames';
import { DescriptionIcon } from '@trello/nachos/icons/description';
import { forTemplate } from 'app/common/lib/util/i18n';
import {
  MarkdownContentType,
  TrelloMarkdown,
} from 'app/src/components/TrelloMarkdown';

import styles from './DescriptionSection.less';

const format = forTemplate('card_detail');

const MAX_DESCRIPTION_LENGTH = 1800;

interface DescriptionSectionProps {
  description: string;
  descriptionData?: string | null;
}

export const DescriptionSection = ({
  description,
  descriptionData,
}: DescriptionSectionProps) => {
  const [isOpen, setIsOpen] = useState(
    description.length <= MAX_DESCRIPTION_LENGTH,
  );

  const showMore = useCallback(() => {
    setIsOpen(true);
  }, [setIsOpen]);

  const customEmojis = {
    textData: JSON.parse(descriptionData || '{}'),
  };

  return (
    <div className={styles.descriptionSection}>
      <div className={styles.descriptionIcon}>
        <DescriptionIcon size="large" />
      </div>
      <h3 className={styles.heading} dir="auto">
        {format('description')}
      </h3>
      <div
        className={classNames(styles.descriptionContent, isOpen && styles.open)}
      >
        <button className={styles.descriptionMask} onClick={showMore}>
          <div className={styles.showMoreButton}>
            {format('show-full-description')}
          </div>
        </button>
        <div className={styles.description}>
          <TrelloMarkdown
            contentType={MarkdownContentType.Description}
            text={description}
            options={customEmojis}
          />
        </div>
      </div>
    </div>
  );
};
